import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Camera, Upload } from "lucide-react";

const PhotoDialogSection = ({ ctx }) => {
  const {
    handlePhotoUpload,
    photoDialogOpen,
    photoFile,
    selectedEmployeeForPhoto,
    setPhotoDialogOpen,
    setPhotoFile,
    uploadingPhoto
  } = ctx;
  return (
    <>
      <Dialog open={photoDialogOpen} onOpenChange={setPhotoDialogOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl">
              UPLOAD PHOTO
              {selectedEmployeeForPhoto && (
                <span className="text-base font-normal text-slate-600 ml-2">
                  - {selectedEmployeeForPhoto.name}
                </span>
              )}
            </DialogTitle>
          </DialogHeader>
          
          <form onSubmit={handlePhotoUpload} className="space-y-4 mt-4">
            {/* Current Photo Preview */}
            <div className="flex justify-center">
              {selectedEmployeeForPhoto?.photo_url ? (
                <img 
                  src={`${process.env.REACT_APP_BACKEND_URL}${selectedEmployeeForPhoto.photo_url}`}
                  alt="Current"
                  className="w-32 h-40 object-cover rounded-sm border-2 border-slate-200"
                />
              ) : (
                <div className="w-32 h-40 bg-slate-100 rounded-sm border-2 border-dashed border-slate-300 flex items-center justify-center">
                  <Camera className="w-12 h-12 text-slate-300" />
                </div>
              )}
            </div>
            
            <p className="text-xs text-center text-slate-500">
              Upload a passport-size photo (JPG/PNG). Max 5MB.
            </p>
            
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Select Photo *</label>
              <input
                type="file"
                accept="image/jpeg,image/png,image/jpg"
                onChange={(e) => setPhotoFile(e.target.files[0])}
                className="w-full px-3 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary text-sm"
              />
            </div>
            
            {photoFile && (
              <div className="flex justify-center">
                <img 
                  src={URL.createObjectURL(photoFile)}
                  alt="Preview"
                  className="w-24 h-32 object-cover rounded-sm border border-primary"
                />
              </div>
            )}
            
            <div className="flex justify-end space-x-3 pt-4">
              <button type="button" onClick={() => setPhotoDialogOpen(false)} className="btn-outline">
                Cancel
              </button>
              <button
                type="submit"
                disabled={uploadingPhoto || !photoFile}
                className="btn-primary flex items-center space-x-2"
              >
                <Upload className="w-4 h-4" />
                <span>{uploadingPhoto ? "Uploading..." : "Upload Photo"}</span>
              </button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PhotoDialogSection;
